import cx from 'classnames'
import { useMemo } from 'react'

import classNames from './styles.module.scss'


interface IProps {
  value: number,
  className?: string,
}

StarsRow.defaultProps = {
  value: 0,
  className: '',
}

export default function StarsRow({
  className,
  value,
}: IProps): JSX.Element | null {
  const starsRender = useMemo(() => {
    if(!value) {
      return null
    }
    let fullStars = Math.floor(value)
    let halfStars = 0
    const remainingValue = value - fullStars

    if((remainingValue >= 0.4 && remainingValue < 1) ||
      (remainingValue >= 1.4 && remainingValue < 2) ||
      (remainingValue >= 2.4 && remainingValue < 3) ||
      (remainingValue >= 3.4 && remainingValue < 4) ||
      (remainingValue >= 4.4 && remainingValue < 4.75)) {
      halfStars = 1
    }

    const stars = []

    for(let i = 0; i < 5; i++) {
      if(fullStars > 0) {
        stars.push(<i data-test="star-full" key={`full-${i}`} className={cx(classNames.star)}/>)
        fullStars--
      } else if(halfStars > 0) {
        stars.push(<i data-test="star-half" key={`half-${i}`} className={cx(classNames.star, classNames.half)}/>)
        halfStars--
      } else {
        stars.push(<i data-test="star-empty" key={`empty-${i}`} className={cx(classNames.star, classNames.empty)}/>)
      }
    }

    return stars
  }, [value])

  return (
    <div className={cx(className, classNames.stars)} data-test="stars-row">
      {starsRender}
    </div>
  )
}
